module.exports = __webpack_public_path__ + "img/shu.69421461.png";